export const IconTheme = {
    baseStyle: {
        color: "gray.500",
    },
    defaultProps: {
        size: "sm",
    }
}